import { Grid, styled } from '@mui/material';
import { Fragment } from 'react';
import { useState } from 'react';
import CreateExpenseEntry from './shared/CreateExpenseEntry';
import ExpenseEntryTable from './shared/ExpenseEntryTable';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const ExpenseEntry = () => {
  const [apiCall, setApiCall] = useState(false);
  function handleApiCall() {
    setApiCall((prev) => !prev);
  }
  return (
    <Fragment>
      <ContentBox className='analytics'>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <CreateExpenseEntry handleApiCall={handleApiCall} />
            <ExpenseEntryTable apiCall={apiCall} setApiCall={setApiCall} />
          </Grid>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default ExpenseEntry;
